export default "__VITE_ASSET__CdoDcPx1__"